import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { faqs } from '../mockData';
import SampleReportSection from '../components/SampleReportSection';

const FAQs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      {/* Hero Section */}
      <section className="bg-white py-12">
        <div className="container mx-auto px-6 text-center">
          <h4 className="text-gray-500 mb-2">Frequently Asked Questions</h4>
          <h1 className="text-4xl font-bold text-gray-900">
            Most Common Questions
          </h1>
        </div>
      </section>

      {/* FAQs Section */}
      <section className="py-8 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto space-y-3">
            {faqs.map((faq, index) => (
              <div
                key={faq.id}
                className="bg-blue-50 rounded-lg overflow-hidden"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full flex justify-between items-center p-5 text-left hover:bg-blue-100 transition-colors"
                >
                  <span className="text-[#1b2d4a] font-medium">
                    {faq.question}
                  </span>
                  <Plus 
                    size={20} 
                    className={`text-gray-500 flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-45' : ''}`} 
                  />
                </button>
                {openIndex === index && (
                  <div className="px-5 pb-5">
                    <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Sample Report Section */}
      <SampleReportSection />

      {/* Contact Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-4 text-gray-900">
              Still have questions?
            </h2>
            <p className="text-gray-600 mb-8">
              Can't find the answer you're looking for? Please reach out to our friendly team.
            </p>
            <a
              href="mailto:info@climbcapital.in"
              className="inline-block bg-yellow-400 text-gray-900 px-8 py-3 rounded-full font-bold hover:bg-yellow-500 transition-colors"
            >
              Contact Us
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQs;
